function reportFile(file, rp, options) {
  const serviceUrl = 'https://report.pearbranch.com/ReportingServer/service';
  // const rfn = 'http://localhost:8180/DataServer/rdagent.jsp';
  // const rsn = 'REM';
  // var param =
  //   '/rfn [' +
  //   rfn +
  //   '] /rsn [' +
  //   rsn +
  //   '] /rv ' +
  //   `tenantKey['isust'] applNo['0111100410OP'] annoId[1898560] stepId[1898565]`;
  // if (pageorders) {
  //   param += ' /rpageorder [' + pageorders + ']';
  // }

  // if (pageorders) {
  //   param += ' /rpageorder [' + pageorders + ']';
  // }

  var viewer = new m2soft.crownix.Viewer(serviceUrl);
  viewer.showToolbarItem(['close']);
  viewer.hideToolbarItem(['doc', 'xls', 'ppt', 'hwp']);

  console.log(file);
  console.log(rp);

  viewer.openFile(file, rp, options);
  $('.crownix-close-button').css('display', 'none');
}
export { reportFile };
